import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Manpower } from "@/components/Manpower";
import { Equipment } from "@/components/Equipment";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { Clients } from "@/components/Clients";
import { ProjectGallery } from "@/components/ProjectGallery";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { Toaster } from "@/components/ui/sonner";
import { usePageSeo } from "@/hooks/usePageSeo";
import ServicesPage from "@/pages/ServicesPage";
import ManpowerPage from "@/pages/ManpowerPage";
import EquipmentPage from "@/pages/EquipmentPage";
import ContactPage from "@/pages/ContactPage";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      window.setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname, hash]);
  return null;
}

function HomePage() {
  usePageSeo({
    title: "Shyam Equipment and Infratech | Manpower Supply & Equipment Rental PAN India",
    description: "PAN India manpower supply, plant and machinery rental, and transaction support for industrial, refinery, EPC, infrastructure, and construction projects.",
    path: "/",
  });
  return (
    <main className="text-industrial-text" data-testid="shyam-home-page">
      <Header />
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Manpower />
      <Equipment />
      <WhyChooseUs />
      <ProjectGallery />
      <Clients />
      <Contact />
      <Footer />
    </main>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, wheelMultiplier: 0.9 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="industrial-grain" aria-hidden="true" />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/manpower" element={<ManpowerPage />} />
          <Route path="/equipment" element={<EquipmentPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <WhatsAppButton />
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
